import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 6,
		cy: 6,
		r: 6,
		fill: "#44CC00"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.69238 6.0018L5.41767 7.61719L8.30777 4.61719",
		stroke: "white",
		strokeWidth: 1.2
	})]
});
export default SvgCheckmark;
